<template>
  <section>
    <div v-if="(isHome() || isViewAllPage()) && !isMyProfile()"
         role="banner">
      <div class="column-view hero">
        <div class="pictures-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FOasam%2FGroup%20389.png?alt=media&token=e7940ee7-fd22-4d58-ba01-8e948e271973">
        </div>
        <div class="hero-content">
          <div class="banner-logo">
            <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FOasam%2FLogo.png?alt=media&token=e816c773-312f-4c4a-8e98-6b0943a19ba7" alt="OASAM logo">
          </div>
          <div class="text-container">
            <h1 class="banner-text">2023 ABSTRACTS:<br>POSTER & PODIUM</h1>
          </div>
        </div>
      </div>
      <div class="hero row-view">
        <div class="banner-logo">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FOasam%2FLogo.png?alt=media&token=e816c773-312f-4c4a-8e98-6b0943a19ba7" alt="OASAM logo">
        </div>
        <div class="text-container">
          <h1 class="banner-text">2023 ABSTRACTS:<br>POSTER & PODIUM</h1>
        </div>
        <div class="pictures-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FOasam%2FGroup%20390.png?alt=media&token=39fa8823-3c70-4776-9d1f-231e2ef02253">
        </div>
      </div>
    </div>
    <div v-if="isPodiumPage()"
         class="hero-podium"
         role="banner">
      <div class="hero-content is-flex">
        <div class="banner-logo">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FOasam%2Foasam-logo-transparancy.png?alt=media&token=4f64c14a-6b7b-4182-aa47-6a3a2b15fccb" alt="OASAM logo">
        </div>
        <h1 class="banner-text">PODIUM SESSIONS</h1>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  methods: {
    isHome: function () {
      return this.$route.fullPath.includes('home')
    },
    isViewAllPage: function () {
      return this.$route.fullPath.includes('viewAll')
    },
    isPodiumPage: function () {
      return this.$route.fullPath.includes('/explore/podium-sessions')
    },
    isMyProfile: function () {
      return this.$route.fullPath.includes('profile')
    }
  }
}

</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';
@font-face {
  font-family: 'Cera Pro';
  src: url('/static/fonts/cera-pro/CeraPro-Bold.ttf');
  font-weight: 600;
  font-style: normal;
}
.hero {
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FOasam%2Fbg%20image%20v2.png?alt=media&token=576d02d6-80e3-474a-b0fe-af04d0b8d4de");
  height: 450px;
  background-size: cover;
  background-position: center;
}
.hero-podium {
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FOasam%2FOASAM_banner_BG2.jpg?alt=media&token=8ea8861a-6d0d-4249-adef-8d5592fbb57d");
  height: 450px;
  background-size: cover;
  background-position: center;
}
.hero-content {
  display: flex;
  margin-right: 27rem;
  margin-top: -1.5rem;
  @media (max-width: 1200px) {
    margin-right: 25rem;
  }
  @media (max-width: 890px) {
    margin-right: 10rem;
  }
}
.banner-logo {
  width: 16rem;
  margin-left: -5rem;
  @media (max-width: 1250px) {
    margin-left: -3rem;
  }
  @media (max-width: 1200px) {
    margin-left: -2rem;
  }
  @media (max-width: 1140px) {
    margin-left: 0rem;
    width: 14rem;
  }
  @media (max-width: 1020px) {
    margin-left: 2.5rem;
    width: 14rem;
  }
  @media (max-width: 940px) {
    margin-left: 4rem;
    width: 12rem;
  }
  @media (max-width: 890px) {
    margin-left: 0rem;
    width: 12rem;
    margin-top: -8rem;
  }
}
.text-container {
  height: 8rem;
  width: 27rem;
  @media (max-width: 1200px) {
    width: 25rem;
  }
  @media (max-width: 1140px) {
    width: 22rem;
  }
  @media (max-width: 1020px) {
    width: 19rem;
  }
}
.banner-text {
  font-family: 'Cera Pro' !important;
  color: white;
  font-weight: 500;
  font-size: 2.5rem;
  text-shadow: 1px 1px 1px #2f2f2f;
  text-align: center;
  margin-top: -0.5rem;
  @media (max-width: 1200px) {
    font-size: 2.3rem;
    padding-top: 0.5rem;
  }
  @media (max-width: 1140px) {
    font-size: 1.9rem;
    padding-top: 0.7rem;
  }
  @media (max-width: 940px) {
    font-size: 1.6rem;
    padding-top: 0.7rem;
  }
  @media (max-width: 890px) {
    font-size: 1.6rem;
    padding-top: 0.7rem;
  }
}
.pictures-container {
  height: 10rem;
  width: 32rem;
  margin-top: -6rem;
  margin-left: 60rem;
  margin-right: 10rem;
  @media (max-width: 1300px) {
    margin-left: 55rem;
  }
  @media (max-width: 1250px) {
    margin-left: 50rem;
    width: 30rem;
    padding-top: 1rem;
  }
  @media (max-width: 1200px) {
    margin-left: 50rem;
    width: 30rem;
    padding-top: 1rem;
  }
  @media (max-width: 1140px) {
    margin-left: 50rem;
    width: 25rem;
    padding-top: 3rem;
  }
  @media (max-width: 1080px) {
    margin-left: 45rem;
    width: 25rem;
    padding-top: 3rem;
  }
  @media (max-width: 1020px) {
    margin-left: 45rem;
    width: 22rem;
    padding-top: 3.5rem;
  }
  @media (max-width: 980px) {
    margin-left: 42rem;
    width: 22rem;
    padding-top: 3.5rem;
  }
  @media (max-width: 890px) {
    margin-left: 10rem;
    width: 18rem;
    padding-top: 3.5rem;
  }
}
.column-view {
  @media (max-width: 890px) {
    display: None;
    flex-direction: column;
  }
}
.row-view {
  @media (min-width: 891px) {
    display: None;
    flex-direction: row;
  }
}
@include mobile {
  .banner-logo {
    width: 12rem;
  }
  .banner-text {
    font-size: 1.6rem;
  }
}
</style>
